import { Dispatch, FC, SetStateAction, useEffect, useState } from "react";
import { useAppDispatch } from "redux/hooks";

import { useMediaQuery } from "context/media/MediaContext";
import { useTranslation } from "react-i18next";
import { TokenInclude } from "helpers/GetToken";
import { setActive } from "redux/slices/EmployeeManagementSlice";
import { RemoveSimBlockAsync } from "services/employeeManagement.service";

import Button from "../../BaseComponents/Button";
import Modal from "../../BaseComponents/Modal";
import { Col, Row, Seperator } from "../../BaseComponents/Flex";
import InsideSpinner from "components/BaseComponents/Spinner/InsideSpinner";
import {
  setServiceError,
  setServiceWarning,
} from "redux/slices/ServiceInlineError";

interface RemoveSimBlokModalProps {
  title?: string;
  message?: string;
  acceptButtonText?: string;
  setIsOpen: Dispatch<SetStateAction<boolean>>;
  rejectButtonText?: string;
  phoneNumber: string;
}

const RemoveSimBlokModal: FC<RemoveSimBlokModalProps> = ({
  title,
  message,
  acceptButtonText,
  rejectButtonText,
  setIsOpen,
  phoneNumber,
}) => {
  const { t } = useTranslation();
  const { isMobile } = useMediaQuery();
  const dispatch = useAppDispatch();
  const token = TokenInclude();

  const [loading, setLoading] = useState<boolean>(false);
  const [pn, setpn] = useState("");

  const onAcceptClick = async () => {
    setLoading(true);
    const simBlock = await RemoveSimBlockAsync(token, pn);
    if (simBlock.IsSuccess) {
      dispatch(setActive(phoneNumber));
      setIsOpen(false);
      setLoading(false);
      dispatch(setServiceWarning(t("successful").toString()));
    } else {
      const errMessage: any = simBlock;

      if (errMessage === "SimBlock.NoBlockError") {
        dispatch(
          setServiceWarning(t("service_simBlock_NoBlockError").toString())
        );
      } else dispatch(setServiceError(errMessage));

      setIsOpen(false);
      setLoading(false);
      return;
    }
  };

  const onRejectClick = (): void => setIsOpen(false);

  useEffect(() => {
    phoneNumber && setpn(phoneNumber);
  }, [phoneNumber]);

  return (
    <Modal info={message} maxWidth={450} setIsOpen={setIsOpen} title={title}>
      <Row justifyContent='center' isResponsive noMargin>
        <Col size={0.3}>
          <Button
            onClick={onAcceptClick}
            text={
              loading ? (
                <InsideSpinner width='30' height='30' />
              ) : (
                acceptButtonText
              )
            }
          />
        </Col>

        <Seperator marginRight={20} marginTop={isMobile ? 10 : 0} />

        <Col size={0.3}>
          <Button
            color='light'
            onClick={onRejectClick}
            text={rejectButtonText}
          />
        </Col>
      </Row>
    </Modal>
  );
};

export default RemoveSimBlokModal;
